<template>
  <div
    class="shopee-container"
    @click="selectLocation($event)"
    id="shopeeContainer"
    @mouseover="overSelection($event)"
    @mouseout="outSelection($event)"
  >
    <div class="shopee-container-mark-layer"></div>
    <div class="header-container exclude">
      <div class="navbar">
        <div class="navbar-left">
          <div class="split-line">
            卖家中心
          </div>
          <div class="split-line">
            下载
          </div>
          <div class="no-split">
            关注我们
          </div>
          <div class="no-split icon-wrap">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-tian7_facebook"></use>
            </svg>
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-instagam"></use>
            </svg>
          </div>
        </div>
        <div class="navbar-space"></div>
        <div class="navbar-right">
          <div class="split-line icon-wrap">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-tongzhi"></use>
            </svg>
            通知
          </div>
          <div class="no-split icon-wrap">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-wenhao"></use>
            </svg>
            帮助中心
          </div>
          <div class="no-split">
            <div>
              注册
            </div>
            <div class="split"></div>
            <div>
              登录
            </div>
          </div>
        </div>
      </div>
      <div class="container-wrapper">
        <div class="logo">
          <svg
            viewBox="0 0 192 65"
            class="shopee-svg-icon header-with-search__shopee-logo icon-shopee-logo"
          >
            <g fill-rule="evenodd">
              <path
                d="M35.6717403 44.953764c-.3333497 2.7510509-2.0003116 4.9543414-4.5823845 6.0575984-1.4379707.6145919-3.36871.9463856-4.896954.8421628-2.3840266-.0911143-4.6237865-.6708937-6.6883352-1.7307424-.7375522-.3788551-1.8370513-1.1352759-2.6813095-1.8437757-.213839-.1790053-.239235-.2937577-.0977428-.4944671.0764015-.1151823.2172535-.3229831.5286218-.7791994.45158-.6616533.5079208-.7446018.5587128-.8221779.14448-.2217688.3792333-.2411091.6107855-.0588804.0243289.0189105.0243289.0189105.0426824.0333083.0379873.0294402.0379873.0294402.1276204.0990653.0907002.0706996.14448.1123887.166248.1287205 2.2265285 1.7438508 4.8196989 2.7495466 7.4376251 2.8501162 3.6423042-.0496401 6.2615109-1.6873341 6.7308041-4.2020035.5160305-2.7675977-1.6565047-5.1582742-5.9070334-6.4908212-1.329344-.4166762-4.6895175-1.7616869-5.3090528-2.1250697-2.9094471-1.7071043-4.2697358-3.9430584-4.0763845-6.7048539.296216-3.8283059 3.8501677-6.6835796 8.340785-6.702705 2.0082079-.004083 4.0121475.4132378 5.937338 1.2244562.6816382.2873109 1.8987274.9496089 2.3189359 1.2633517.2420093.1777159.2898136.384872.1510957.60836-.0774686.12958-.2055158.3350171-.4754821.7632974l-.0029878.0047276c-.3553311.5640922-.3664286.5817134-.447952.7136572-.140852.2144625-.3064598.2344475-.5604202.0732783-2.0600669-1.3839063-4.3437898-2.0801572-6.8554368-2.130442-3.126914.061889-5.4706057 1.9228561-5.6246892 4.4579402-.0409751 2.2896772 1.676352 3.9613243 5.3858811 5.2358503 7.529819 2.4196871 10.4113092 5.25648 9.869029 9.7292478M26.3725216 5.42669372c4.9022893 0 8.8982174 4.65220288 9.0851664 10.47578358H17.2875686c.186949-5.8235807 4.1828771-10.47578358 9.084953-10.47578358m25.370857 11.57065968c0-.6047069-.4870064-1.0948761-1.0875481-1.0948761h-11.77736c-.28896-7.68927544-5.7774923-13.82058185-12.5059489-13.82058185-6.7282432 0-12.2167755 6.13130641-12.5057355 13.82058185l-11.79421958.0002149c-.59136492.0107446-1.06748731.4968309-1.06748731 1.0946612 0 .0285807.00106706.0569465.00320118.0848825H.99995732l1.6812605 37.0613963c.00021341.1031483.00405483.2071562.01173767.3118087.00170729.0236381.003628.0470614.00554871.0704847l.00362801.0782207.00405483.004083c.25545428 2.5789222 2.12707837 4.6560709 4.67201764 4.7519129l.00576212.0055872h37.4122078c.0177132.0002149.0354264.0004298.0531396.0004298.0177132 0 .0354264-.0002149.0531396-.0004298h.0796027l.0017073-.0015043c2.589329-.0706995 4.6867431-2.1768587 4.9082648-4.787585l.0012805-.0012893.0017073-.0350275c.0021341-.0275062.0040548-.0547975.0057621-.0823037.0040548-.065757.0068292-.1312992.0078963-.1964115l1.8344904-37.207738h-.0012805c.001067-.0186956.0014939-.0376062.0014939-.0565167M176.465457 41.1518926c.720839-2.3512494 2.900423-3.9186779 5.443734-3.9186779 2.427686 0 4.739107 1.6486899 5.537598 3.9141989l.054826.1556978h-11.082664l.046506-.1512188zm13.50267 3.4063683c.014933.0006399.014933.0006399.036906.0008531.021973-.0002132.021973-.0002132.044372-.0008531.53055-.0243144.950595-.4766911.950595-1.0271786 0-.0266606-.000853-.0496953-.00256-.0865936.000427-.0068251.000427-.020262.000427-.0635588 0-5.1926268-4.070748-9.4007319-9.09145-9.4007319-5.020488 0-9.091235 4.2081051-9.091235 9.4007319 0 .3871116.022399.7731567.067838 1.1568557l.00256.0204753.01408.1013102c.250022 1.8683731 1.047233 3.5831812 2.306302 4.9708108-.00064-.0006399.00064.0006399.007253.0078915 1.396026 1.536289 3.291455 2.5833031 5.393601 2.9748936l.02752.0053321v-.0027727l.13653.0228215c.070186.0119439.144211.0236746.243409.039031 2.766879.332724 5.221231-.0661182 7.299484-1.1127057.511777-.2578611.971928-.5423827 1.37064-.8429007.128211-.0968312.243622-.1904632.34346-.2781231.051412-.0452164.092372-.083181.114131-.1051493.468898-.4830897.498124-.6543572.215249-1.0954297-.31146-.4956734-.586228-.9179769-.821744-1.2675504-.082345-.1224254-.154023-.2267215-.214396-.3133151-.033279-.0475624-.033279-.0475624-.054399-.0776356-.008319-.0117306-.008319-.0117306-.013866-.0191956l-.00256-.0038391c-.256208-.3188605-.431565-.3480805-.715933-.0970445-.030292.0268739-.131624.1051493-.14997.1245582-1.999321 1.775381-4.729508 2.3465571-7.455854 1.7760208-.507724-.1362888-.982595-.3094759-1.419919-.5184948-1.708127-.8565509-2.918343-2.3826022-3.267563-4.1490253l-.02752-.1394881h13.754612zM154.831964 41.1518926c.720831-2.3512494 2.900389-3.9186779 5.44367-3.9186779 2.427657 0 4.739052 1.6486899 5.537747 3.9141989l.054612.1556978h-11.082534l.046505-.1512188zm13.502512 3.4063683c.015146.0006399.015146.0006399.037118.0008531.02176-.0002132.02176-.0002132.044159-.0008531.530543-.0243144.950584-.4766911.950584-1.0271786 0-.0266606-.000854-.0496953-.00256-.0865936.000426-.0068251.000426-.020262.000426-.0635588 0-5.1926268-4.070699-9.4007319-9.091342-9.4007319-5.020217 0-9.091343 4.2081051-9.091343 9.4007319 0 .3871116.022826.7731567.068051 1.1568557l.00256.0204753.01408.1013102c.250019 1.8683731 1.04722 3.5831812 2.306274 4.9708108-.00064-.0006399.00064.0006399.007254.0078915 1.396009 1.536289 3.291417 2.5833031 5.393538 2.9748936l.027519.0053321v-.0027727l.136529.0228215c.070184.0119439.144209.0236746.243619.039031 2.766847.332724 5.22117-.0661182 7.299185-1.1127057.511771-.2578611.971917-.5423827 1.370624-.8429007.128209-.0968312.243619-.1904632.343456-.2781231.051412-.0452164.09237-.083181.11413-.1051493.468892-.4830897.498118-.6543572.215246-1.0954297-.311457-.4956734-.586221-.9179769-.821734-1.2675504-.082344-.1224254-.154022-.2267215-.21418-.3133151-.033492-.0475624-.033492-.0475624-.054612-.0776356-.008319-.0117306-.008319-.0117306-.013866-.0191956l-.002346-.0038391c-.256419-.3188605-.431774-.3480805-.716138-.0970445-.030292.0268739-.131623.1051493-.149969.1245582-1.999084 1.775381-4.729452 2.3465571-7.455767 1.7760208-.507717-.1362888-.982582-.3094759-1.419902-.5184948-1.708107-.8565509-2.918095-2.3826022-3.267311-4.1490253l-.027733-.1394881h13.754451zM138.32144123 49.7357905c-3.38129629 0-6.14681004-2.6808521-6.23169343-6.04042014v-.31621743c.08401943-3.35418649 2.85039714-6.03546919 6.23169343-6.03546919 3.44242097 0 6.23320537 2.7740599 6.23320537 6.1960534 0 3.42199346-2.7907844 6.19605336-6.23320537 6.19605336m.00172791-15.67913203c-2.21776751 0-4.33682838.7553485-6.03989586 2.140764l-.19352548.1573553V34.6208558c0-.4623792-.0993546-.56419733-.56740117-.56419733h-2.17651376c-.47409424 0-.56761716.09428403-.56761716.56419733v27.6400724c0 .4539841.10583425.5641973.56761716.5641973h2.17651376c.46351081 0 .56740117-.1078454.56740117-.5641973V50.734168l.19352548.1573553c1.70328347 1.3856307 3.82234434 2.1409792 6.03989586 2.1409792 5.27140956 0 9.54473746-4.2479474 9.54473746-9.48802964 0-5.239867-4.2733279-9.48781439-9.54473746-9.48781439M115.907646 49.5240292c-3.449458 0-6.245805-2.7496948-6.245805-6.1425854 0-3.3928907 2.79656-6.1427988 6.245805-6.1427988 3.448821 0 6.24538 2.7499081 6.24538 6.1427988 0 3.3926772-2.796346 6.1425854-6.24538 6.1425854m.001914-15.5438312c-5.28187 0-9.563025 4.2112903-9.563025 9.4059406 0 5.1944369 4.281155 9.4059406 9.563025 9.4059406 5.281657 0 9.562387-4.2115037 9.562387-9.4059406 0-5.1946503-4.280517-9.4059406-9.562387-9.4059406M94.5919049 34.1890939c-1.9281307 0-3.7938902.6198995-5.3417715 1.7656047l-.188189.1393105V23.2574169c0-.4254677-.1395825-.5643476-.5649971-.5643476h-2.2782698c-.4600414 0-.5652122.1100273-.5652122.5643476v29.2834155c0 .443339.1135587.5647782.5652122.5647782h2.2782698c.4226187 0 .5649971-.1457701.5649971-.5647782v-9.5648406c.023658-3.011002 2.4931278-5.4412923 5.5299605-5.4412923 3.0445753 0 5.516841 2.4421328 5.5297454 5.4630394v9.5430935c0 .4844647.0806524.5645628.5652122.5645628h2.2726775c.481764 0 .565212-.0824666.565212-.5645628v-9.5710848c-.018066-4.8280677-4.0440197-8.7806537-8.9328471-8.7806537M62.8459442 47.7938061l-.0053397.0081519c-.3248668.4921188-.4609221.6991347-.5369593.8179812-.2560916.3812097-.224267.551113.1668119.8816949.91266.7358184 2.0858968 1.508535 2.8774525 1.8955369 2.2023021 1.076912 4.5810275 1.646045 7.1017886 1.6975309 1.6283921.0821628 3.6734936-.3050536 5.1963734-.9842376 2.7569891-1.2298679 4.5131066-3.6269626 4.8208863-6.5794607.4985136-4.7841067-2.6143125-7.7747902-10.6321784-10.1849709l-.0021359-.0006435c-3.7356476-1.2047686-5.4904836-2.8064071-5.4911243-5.0426086.1099976-2.4715346 2.4015793-4.3179454 5.4932602-4.4331449 2.4904317.0062212 4.6923065.6675996 6.8557356 2.0598624.4562232.2767364.666607.2256796.9733188-.172263.035242-.0587797.1332787-.2012238.543367-.790093l.0012815-.0019308c.3829626-.5500403.5089793-.7336731.5403767-.7879478.258441-.4863266.2214903-.6738208-.244985-1.0046173-.459427-.3290803-1.7535544-1.0024722-2.4936356-1.2978721-2.0583439-.8211991-4.1863175-1.2199998-6.3042524-1.1788111-4.8198184.1046878-8.578747 3.2393171-8.8265087 7.3515337-.1572005 2.9703036 1.350301 5.3588174 4.5000778 7.124567.8829712.4661613 4.1115618 1.6865902 5.6184225 2.1278667 4.2847814 1.2547527 6.5186944 3.5630343 6.0571315 6.2864205-.4192725 2.4743234-3.0117991 4.1199394-6.6498372 4.2325647-2.6382344-.0549182-5.2963324-1.0217793-7.6043603-2.7562084-.0115337-.0083664-.0700567-.0519149-.1779185-.1323615-.1516472-.1130543-.1516472-.1130543-.1742875-.1300017-.4705335-.3247898-.7473431-.2977598-1.0346184.1302162-.0346012.0529875-.3919333.5963776-.5681431.8632459"
              ></path>
            </g>
          </svg>
        </div>
        <div class="search-wrap" id="searchWrap">
          <div class="search-box">
            <div class="input-view">
              <input type="text" v-model="search" />
              <div class="icon" id="searchBtn" @click="handleSearch">
                <svg
                  t="1623034943568"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="9113"
                  width="14"
                  height="14"
                >
                  <path
                    d="M435.2 51.2c212.0704 0 384 171.9296 384 384 0 87.6544-29.3632 168.448-78.7968 233.0624l208.8704 213.6832a12.8 12.8 0 0 1-0.2048 18.1248l-54.9376 53.6832a12.8 12.8 0 0 1-18.0992-0.2048l-208.128-212.8896A382.3104 382.3104 0 0 1 435.2 819.2C223.1296 819.2 51.2 647.2704 51.2 435.2 51.2 223.1296 223.1296 51.2 435.2 51.2z m0 102.4C279.68 153.6 153.6 279.68 153.6 435.2s126.08 281.6 281.6 281.6 281.6-126.08 281.6-281.6S590.72 153.6 435.2 153.6z"
                    p-id="9114"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="search-info" id="searchInfo">
              <span @click="clickSearchInfo('Lapsang souchong')">
                Lapsang souchong
              </span>
              <span @click="clickSearchInfo('Dahongpao Tea')">
                Dahongpao Tea
              </span>
              <span @click="clickSearchInfo('jasmine tea')">
                Jasmine tea
              </span>
              <span @click="clickSearchInfo('Green Tea')">
                Green Tea
              </span>
            </div>
          </div>
        </div>
        <div class="shopcar">
          <svg
            t="1623034757222"
            class="icon"
            viewBox="0 0 1028 1024"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            p-id="8282"
            width="200"
            height="200"
          >
            <path
              d="M340.26666667 778.92266667q18.64533333 0 35.328 6.86933333t28.94933333 19.136 19.62666667 28.94933333 7.36 35.328-7.36 35.328-19.62666667 28.94933334-28.94933333 19.62666666-35.328 7.36q-19.62666667 0-36.30933334-7.36t-28.94933333-19.62666666-19.62666667-28.94933334-7.36-35.328 7.36-35.328 19.62666667-28.94933333 28.94933333-19.136 36.30933334-6.86933333zM748.50133333 780.88533333q18.64533333 0 35.81866667 6.86933334t29.44 19.136 19.62666667 28.94933333 7.36 35.328-7.36 35.328-19.62666667 28.94933333-29.44 19.62666667-35.81866667 7.36-35.328-7.36-28.94933333-19.62666667-19.62666667-28.94933333-7.36-35.328 7.36-35.328 19.62666667-28.94933333 28.94933333-19.136 35.328-6.86933334zM913.36533333 223.488q27.47733333 0 42.688 7.36t21.58933334 18.15466667 5.888 23.06133333-3.43466667 21.09866667-12.75733333 36.30933333-21.09866667 60.352-22.57066667 65.25866667-18.15466666 51.02933333q-12.75733333 39.25333333-31.89333334 54.464t-47.59466666 15.21066667l-34.34666667 0-62.80533333 0-82.432 0-92.24533334 0-243.37066666 0 13.73866666 88.32 495.57333334 0q47.104 0 47.104 40.23466666 0 19.62666667-9.32266667 34.34666667t-36.8 13.73866667l-47.104 0-90.28266667 0-113.83466666 0-114.816 0-95.18933334 0-52.992 0q-19.62666667 0-32.87466666-8.832t-22.08-23.06133334-14.22933334-30.912-8.34133333-31.40266666q-0.98133333-5.888-5.39733333-28.45866667t-10.79466667-56.42666667-14.22933333-75.56266666-15.70133334-83.904q-18.64533333-99.11466667-42.19733333-220.8l-73.6 0q-14.72 0-24.53333333-7.36t-16.192-17.664-8.832-22.08-2.45333334-21.58933334q0-19.62666667 13.248-32.384t35.81866667-11.776l99.11466667 0q19.62666667 0 31.40266666 5.888t18.64533334 14.72 9.81333333 18.15466667 4.90666667 16.192q1.96266667 7.85066667 3.92533333 22.08t3.92533333 28.94933333q2.944 17.664 5.888 37.29066667l671.232 0zM877.056 310.82666667l-614.31466667-1.96266667 34.34666667 177.62133333 513.23733333 0.98133334z"
              p-id="8283"
            ></path>
          </svg>
        </div>
      </div>
    </div>
    <el-scrollbar class="elscrollbar1" ref="elscrollbar1" :class="{ hid: hid }">
      <div class="main-container">
        <div class="main-container-view">
          <div class="product-content">
            <div class="section-title exclude" style="margin-bottom: 0">
              <div class="section-title-txt">
                <div class="keyword exclude">
                  "<span>{{ products.axiosParams.keyword }}</span
                  >"
                </div>
                <div class="txt exclude">
                  相关的卖场
                </div>
              </div>
              <div class="more-link exclude noerror">
                <div
                  :class="
                    activeItem === '#location-item-3' &&
                    items[activeItem].actived &&
                    items[activeItem].isActive
                      ? 'mark animate__animated animate__flash animate__repeat-2'
                      : ''
                  "
                  class="more-link-view exclude noerror"
                  id="moreLink"
                  @click="showMore"
                >
                  <span class="exclude noerror">查看更多</span>
                  <i class="el-icon-arrow-right exclude noerror"></i>
                </div>
              </div>
            </div>
            <div class="seller-item" id="sellerItem">
              <div class="shop-img">
                <img :src="sellers.items[0].logo" alt="" />
              </div>
              <div class="shop-info exclude">
                <div class="info-item-nickname">
                  {{ sellers.items[0].nickName }}
                </div>
                <div class="info-item-username">
                  {{ sellers.items[0].userName }}
                </div>
                <div class="info-item-follow">
                  {{ sellers.items[0].follow }}
                </div>
              </div>
              <div class="shop-statistics exclude">
                <div class="shop-statistics-item">
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        style="width: 14px;height: 14px"
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon icon-products exclude"
                      >
                        <g class="exclude">
                          <path
                            class="exclude"
                            d="m10 1 4.5 2.5-.5 3h-2v7.5h-9v-7.5h-2l-.5-3 4.6-2.5c.3 1.1 1.3 1.9 2.4 1.9s2.1-.8 2.5-1.9z"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                          ></path>
                          <line
                            class="exclude"
                            fill="none"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="3"
                            x2="12"
                            y1="11.5"
                            y2="11.5"
                          ></line>
                        </g>
                      </svg>
                      <span class="exclude">
                        {{ sellers.items[0].products }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      商品
                    </div>
                  </div>
                </div>
                <div
                  :class="
                    activeItem === '#location-item-2' &&
                    items[activeItem].actived &&
                    items[activeItem].isActive
                      ? 'mark animate__animated animate__flash animate__repeat-2'
                      : ''
                  "
                  class="shop-statistics-item "
                  id="shop-statistics-item-sales"
                >
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        t="1625644219567"
                        class="icon exclude"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="955"
                        width="200"
                        height="200"
                      >
                        <path
                          d="M512.33140179 15.61534137a265.12143803 265.12143803 0 0 1 265.12143803 265.12143802h132.56071902a44.18690591 44.18690591 0 0 1 44.1869059 44.18690591l-44.1869059 618.61668915a44.18690591 44.18690591 0 0 1-44.18690592 44.1869059h-706.99050225a44.18690591 44.18690591 0 0 1-44.1869059-44.1869059l-44.18690591-618.61668915a44.18690591 44.18690591 0 0 1 44.18690591-44.18690591h132.560719a265.12143803 265.12143803 0 0 1 265.12143802-265.12143802z m176.74762493 265.12143802a176.74762492 176.74762492 0 1 0-353.49524983 0h353.49524983z m-530.24287605 88.37381181l44.1869072 530.24287605h618.61668786l44.18690719-530.24287605h-706.99050225z m220.93453211 309.30834523v88.3738118a44.18690591 44.18690591 0 0 1-88.37381311 0v-88.3738118a44.18690591 44.18690591 0 0 1 88.37381311 0z m176.74762492-44.18690721v132.56071901a44.18690591 44.18690591 0 0 1-88.37381181 0v-132.56071901a44.18690591 44.18690591 0 0 1 88.37381181 0z m176.74762622-88.3738118v220.93453081a44.18690591 44.18690591 0 0 1-88.37381312 0v-220.93453081a44.18690591 44.18690591 0 0 1 88.37381312 0z"
                          p-id="956"
                        ></path>
                      </svg>
                      <span class="exclude">
                        {{ sellers.items[0].summary }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      销量
                    </div>
                  </div>
                </div>
                <div
                  :class="
                    activeItem === '#location-item-4' &&
                    items[activeItem].actived &&
                    items[activeItem].isActive
                      ? 'mark animate__animated animate__flash animate__repeat-2'
                      : ''
                  "
                  class="shop-statistics-item "
                  id="shop-statistics-item-evaluate"
                >
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon icon-rating exclude"
                      >
                        <polygon
                          fill="none"
                          points="7.5 .8 9.7 5.4 14.5 5.9 10.7 9.1 11.8 14.2 7.5 11.6 3.2 14.2 4.3 9.1 .5 5.9 5.3 5.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></polygon>
                      </svg>
                      <span class="exclude">
                        {{ sellers.items[0].comment }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      商品评价
                    </div>
                  </div>
                </div>
                <div class="shop-statistics-item">
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon exclude"
                      >
                        <g>
                          <polygon
                            fill="none"
                            points="14 10.8 7 10.8 3 13.8 3 10.8 1 10.8 1 1.2 14 1.2"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                          ></polygon>
                          <circle cx="4" cy="5.8" r="1" stroke="none"></circle>
                          <circle
                            cx="7.5"
                            cy="5.8"
                            r="1"
                            stroke="none"
                          ></circle>
                          <circle cx="11" cy="5.8" r="1" stroke="none"></circle>
                        </g>
                      </svg>
                      <span class="exclude">
                        {{ sellers.items[0].response }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      聊聊回应率
                    </div>
                  </div>
                </div>
                <div class="shop-statistics-item">
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon exclude"
                      >
                        <g>
                          <polyline
                            fill="none"
                            points="7.2 3.5 7.2 7.8 10.5 7.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                          ></polyline>
                          <circle
                            cx="7.5"
                            cy="7.5"
                            fill="none"
                            r="6.5"
                            stroke-miterlimit="10"
                          ></circle>
                        </g>
                      </svg>
                      <span class="exclude">
                        {{ sellers.items[0].responseTime }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      回应速度
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="section-title">
              <div class="section-title-txt exclude">
                <div class="icon exclude">
                  <svg
                    width="16"
                    height="22"
                    viewBox="0 0 18 24"
                    class="shopee-svg-icon icon-hint-bulb exclude"
                  >
                    <g transform="translate(-355 -149)">
                      <g transform="translate(355 149)">
                        <g
                          fill-rule="nonzero"
                          transform="translate(5.4 19.155556)"
                        >
                          <path
                            d="m1.08489412 1.77777778h5.1879153c.51164401 0 .92641344-.39796911.92641344-.88888889s-.41476943-.88888889-.92641344-.88888889h-5.1879153c-.51164402 0-.92641345.39796911-.92641345.88888889s.41476943.88888889.92641345.88888889z"
                          ></path>
                          <g transform="translate(1.9 2.666667)">
                            <path
                              d="m .75 1.77777778h2.1c.41421356 0 .75-.39796911.75-.88888889s-.33578644-.88888889-.75-.88888889h-2.1c-.41421356 0-.75.39796911-.75.88888889s.33578644.88888889.75.88888889z"
                            ></path>
                          </g>
                        </g>
                        <path
                          d="m8.1 8.77777718v4.66666782c0 .4295545.40294373.7777772.9.7777772s.9-.3482227.9-.7777772v-4.66666782c0-.42955447-.40294373-.77777718-.9-.77777718s-.9.34822271-.9.77777718z"
                          fill-rule="nonzero"
                        ></path>
                        <path
                          d="m8.1 5.33333333v.88889432c0 .49091978.40294373.88888889.9.88888889s.9-.39796911.9-.88888889v-.88889432c0-.49091977-.40294373-.88888889-.9-.88888889s-.9.39796912-.9.88888889z"
                          fill-rule="nonzero"
                        ></path>
                        <path
                          d="m8.80092773 0c-4.86181776 0-8.80092773 3.97866667-8.80092773 8.88888889 0 1.69422221.47617651 3.26933331 1.295126 4.61333331l2.50316913 3.9768889c.30201078.4782222.84303623.7697778 1.42482388.7697778h7.17785139c.7077799 0 1.3618277-.368 1.7027479-.9617778l2.3252977-4.0213333c.7411308-1.2888889 1.1728395-2.7786667 1.1728395-4.37688891 0-4.91022222-3.9409628-8.88888889-8.80092777-8.88888889m0 1.77777778c3.82979317 0 6.94810087 3.18933333 6.94810087 7.11111111 0 1.24444441-.3168334 2.43022221-.9393833 3.51466671l-2.3252977 4.0213333c-.0166754.0284444-.0481735.0462222-.0833772.0462222h-7.07224026l-2.43461454-3.8648889c-.68184029-1.12-1.04128871-2.4053333-1.04128871-3.71733331 0-3.92177778 3.11645483-7.11111111 6.94810084-7.11111111"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="keyword exclude">
                  "<span class="exclude">{{
                    products.axiosParams.keyword
                  }}</span
                  >"
                </div>
                <div class="txt exclude">
                  搜索的结果
                </div>
              </div>
            </div>
            <div class="filter-wrap exclude">
              <div class="filter-condition">
                <div class="label exclude">
                  筛选
                </div>
                <div class="condition-items exclude">
                  <div class="item active exclude">
                    综合排名
                  </div>
                </div>
              </div>
              <div class="pagination-wrap">
                <div class="num exclude">
                  <span class="current exclude">
                    {{ products.pagiation.current }}
                  </span>
                  /
                  <span class="total exclude">
                    {{
                      Math.ceil(
                        products.items.length / products.pagiation.count
                      )
                    }}
                  </span>
                </div>
                <div class="prev-next exclude noerror">
                  <div
                    class="prev btn exclude noerror"
                    :class="{ disabled: products.pagiation.current === 1 }"
                    @click="
                      products.pagiation.current > 1
                        ? products.pagiation.current--
                        : ''
                    "
                  >
                    <i class="el-icon-arrow-left exclude noerror"></i>
                  </div>
                  <div
                    class="next btn exclude noerror"
                    @click="
                      () => {
                        Math.ceil(
                          products.items.length / products.pagiation.count
                        ) > products.pagiation.current
                          ? products.pagiation.current++
                          : '';
                      }
                    "
                  >
                    <i class="el-icon-arrow-right exclude noerror"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="product-wrapper exclude">
              <a
                href="javascript:;"
                class="product-item"
                v-for="(item, index) in productItems"
                :key="index"
              >
                <div class="product-img">
                  <img :src="item.image" alt="" />
                </div>
                <div class="product-details exclude">
                  <div class="product-title" :title="item.title">
                    {{ item.title }}
                  </div>
                  <div class="product-seller">
                    <span v-for="label in item.labels" :key="label">
                      {{ label }}
                    </span>
                  </div>
                  <div
                    :class="
                      activeItem === '#location-item-1' &&
                      items[activeItem].actived &&
                      items[activeItem].isActive
                        ? 'mark animate__animated animate__flash animate__repeat-2'
                        : ''
                    "
                    id="product-price"
                    class="product-price"
                  >
                    {{ item.salePrice }}
                  </div>
                  <div class="product-other"></div>
                  <div class="product-shop">
                    {{ item.place }}
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
    <el-scrollbar
      class="elscrollbar2"
      ref="elscrollbar2"
      :class="{ hid: !hid }"
      id="sellerContent"
    >
      <div class="main-container">
        <div class="main-container-view">
          <div class="seller-content">
            <div class="section-title exclude" style="margin-bottom: 0">
              <div class="section-title-txt">
                <div class="keyword exclude">
                  "<span class="exclude">Tea</span>"
                </div>
                <div class="txt exclude">
                  相关的卖场
                </div>
              </div>
              <div class="more-link exclude noerror" @click="back" id="back">
                <span class="exclude noerror">返回</span>
                <i class="el-icon-arrow-right exclude noerror"></i>
              </div>
            </div>
            <div
              :class="
                activeItem === '#location-item-3' &&
                items[activeItem].actived &&
                items[activeItem].isActive
                  ? 'mark animate__animated animate__flash animate__repeat-2'
                  : ''
              "
              id="seller-items"
              class="seller-item"
              v-for="(item, index) in sellers.items"
              :key="index"
            >
              <div class="shop-img">
                <img :src="item.logo" alt="" />
              </div>
              <div class="shop-info exclude">
                <div class="info-item-nickname">
                  {{ item.nickName }}
                </div>
                <div class="info-item-username">
                  {{ item.userName }}
                </div>
                <div class="info-item-follow">
                  {{ item.follow }}
                </div>
              </div>
              <div class="shop-statistics exclude">
                <div class="shop-statistics-item">
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        style="width: 14px;height: 14px"
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon icon-products exclude"
                      >
                        <g>
                          <path
                            d="m10 1 4.5 2.5-.5 3h-2v7.5h-9v-7.5h-2l-.5-3 4.6-2.5c.3 1.1 1.3 1.9 2.4 1.9s2.1-.8 2.5-1.9z"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                          ></path>
                          <line
                            fill="none"
                            stroke-linecap="round"
                            stroke-miterlimit="10"
                            x1="3"
                            x2="12"
                            y1="11.5"
                            y2="11.5"
                          ></line>
                        </g>
                      </svg>
                      <span class="exclude">
                        {{ item.products }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      商品
                    </div>
                  </div>
                </div>
                <div class="shop-statistics-item">
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon icon-rating exclude"
                      >
                        <polygon
                          fill="none"
                          points="7.5 .8 9.7 5.4 14.5 5.9 10.7 9.1 11.8 14.2 7.5 11.6 3.2 14.2 4.3 9.1 .5 5.9 5.3 5.4"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-miterlimit="10"
                        ></polygon>
                      </svg>
                      <span class="exclude">
                        {{ item.comment }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      商品评价
                    </div>
                  </div>
                </div>
                <div class="shop-statistics-item">
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon exclude "
                      >
                        <g>
                          <polygon
                            fill="none"
                            points="14 10.8 7 10.8 3 13.8 3 10.8 1 10.8 1 1.2 14 1.2"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                          ></polygon>
                          <circle cx="4" cy="5.8" r="1" stroke="none"></circle>
                          <circle
                            cx="7.5"
                            cy="5.8"
                            r="1"
                            stroke="none"
                          ></circle>
                          <circle cx="11" cy="5.8" r="1" stroke="none"></circle>
                        </g>
                      </svg>
                      <span class="exclude">
                        {{ item.response }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      聊聊回应率
                    </div>
                  </div>
                </div>
                <div class="shop-statistics-item">
                  <div class="shop-statistics-item-wrapper exclude">
                    <div class="item-header exclude">
                      <svg
                        enable-background="new 0 0 15 15"
                        viewBox="0 0 15 15"
                        x="0"
                        y="0"
                        class="shopee-svg-icon exclude"
                      >
                        <g>
                          <polyline
                            fill="none"
                            points="7.2 3.5 7.2 7.8 10.5 7.8"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-miterlimit="10"
                          ></polyline>
                          <circle
                            cx="7.5"
                            cy="7.5"
                            fill="none"
                            r="6.5"
                            stroke-miterlimit="10"
                          ></circle>
                        </g>
                      </svg>
                      <span class="exclude">
                        {{ item.responseTime }}
                      </span>
                    </div>
                    <div class="item-text exclude">
                      回应速度
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
export default {
  props: ["activeItem", "DriverInstance", "items"],
  data() {
    return {
      hid: false,
      search: "Tea",
      products: {
        loading: false,
        items: [],
        axiosParams: {
          country: "",
          tea: "",
          keyword: "Tea",
          limit: 9999,
        },
        pagiation: {
          current: 1,
          total: "",
          count: 10,
        },
      },
      sellers: {
        axiosParams: {
          country: "",
          tea: "",
          limit: 9999,
        },
        items: [{}],
        pagiation: {
          current: 1,
          total: "",
          count: 10,
        },
      },
    };
  },
  computed: {
    productItems: function() {
      return this.products.items.slice(
        (this.products.pagiation.current - 1) * this.products.pagiation.count,
        this.products.pagiation.current * this.products.pagiation.count
      );
    },
  },
  created() {
    this.getProduct();
    this.$axios
      .post("/student/data/present/platform/seller", this.sellers.axiosParams)
      .then((res) => {
        if (res.succeed) {
          this.sellers.items = res.items;
        }
      });
  },
  methods: {
    overSelection(e) {
      e.target.classList.add("overing");
    },
    outSelection(e) {
      e.target.classList.remove("overing");
    },
    selectLocation(e) {
      if (
        e.target.nodeName !== "svg" &&
        e.target.className.indexOf("noerror") > -1
      ) {
        return false;
      }
      function getDefault(target, trueId, endClass) {
        if (!target) {
          return false;
        }
        if (target.id === trueId) {
          return true;
        } else if (target.className === endClass) {
          return false;
        } else {
          return getDefault(target.parentNode, trueId, endClass);
        }
      }

      function getParent(dom) {
        if (dom.nodeName === "svg" || dom.className.indexOf("exclude") > -1) {
          return getParent(dom.parentNode);
        } else {
          return dom;
        }
      }

      const animateCSS = (element, animation, prefix = "animate__") =>
        // We create a Promise and return it
        new Promise((resolve) => {
          const animationName = `${prefix}${animation}`;
          const node = element;

          node.classList.add(`${prefix}animated`, animationName, "error");

          // When the animation ends, we clean the classes and resolve the Promise
          function handleAnimationEnd(event) {
            event.stopPropagation();
            node.classList.remove(`${prefix}animated`, animationName, "error");
            resolve("Animation ended");
          }

          node.addEventListener("animationend", handleAnimationEnd, {
            once: true,
          });
        });

      // this.$emit('selectLocation',e.target.className)
      if (
        (this.activeItem === "#location-item-1" &&
          e.target.id === "product-price") ||
        (this.activeItem === "#location-item-2" &&
          getDefault(
            e.target,
            "shop-statistics-item-sales",
            "shopee-container"
          )) ||
        (this.activeItem === "#location-item-3" &&
          getDefault(e.target, "seller-items", "elscrollbar2")) ||
        (this.activeItem === "#location-item-4" &&
          getDefault(
            e.target,
            "shop-statistics-item-evaluate",
            "shopee-container"
          ))
      ) {
        this.$emit("changeItems", {
          [this.activeItem]: Object.assign({}, this.items[this.activeItem], {
            actived: true,
          }),
        });
        return false;
      } else {
        animateCSS(getParent(e.target), "headShake");
      }
    },
    showMore() {
      this.hid = true;
      setTimeout(() => {
        if (this.DriverInstance?.currentStep === 5) {
          this.$emit("driverNext");
        }
      }, 100);
    },
    back() {
      this.hid = false;
      if (this.DriverInstance?.currentStep === 6) {
        this.$emit("driverNext");
      }
    },
    getProduct() {
      this.$axios
        .post(
          "/student/data/present/platform/product",
          this.products.axiosParams
        )
        .then((res) => {
          if (res.succeed) {
            this.products.items = res.items;
          }
        });
    },
    clickSearchInfo(label) {
      this.search = label;
    },
    handleSearch() {
      if (this.search === "") {
        this.products.axiosParams.keyword = this.search = "Tea";
      } else {
        this.products.axiosParams.keyword = this.search;
        this.products.pagiation.current = 1;
        this.getProduct();
      }
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
* {
  font-family: Roboto, "Helvetica Neue", Helvetica, Arial, æ–‡æ³‰é©›æ­£é»‘,
    "WenQuanYi Zen Hei", "Hiragino Sans GB", "å„·é»‘ Pro", "LiHei Pro",
    "Heiti TC", å¾®è»Ÿæ­£é»‘é«”, "Microsoft JhengHei UI", "Microsoft JhengHei",
    sans-serif;
}

* {
  border: 1px solid transparent;
}

.product-content .error:not(.exclude),
.elscrollbar2 .seller-content .error:not(.exclude) {
  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fe4a49;
    opacity: 0.9;
    z-index: 999;
  }
  &:after {
    content: "错误选择";
    font-family: "Microsoft YaHei", serif;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: #ffffff;
    z-index: 999;
  }
}

.product-content *:not(.exclude):hover {
  cursor: pointer;
  border-color: #fe4a49;
}
.elscrollbar2 .seller-content *:not(.exclude):hover {
  cursor: pointer;
  border-color: #fe4a49;
}

.shopee-container {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  position: relative;

  .header-container {
    padding: 0 20px;
    background: linear-gradient(-180deg, #f53d2d, #f63);

    .navbar {
      height: 34px;
      display: flex;
      align-items: center;
      color: white;

      svg {
        width: 16px;
        height: 16px;
        fill: white;
      }

      .navbar-left,
      .navbar-right {
        display: flex;
        align-items: center;

        div.split {
          height: 12px;
          width: 1px;
          margin: 0 12px;
          background: white;
        }

        div.no-split {
          display: flex;
          align-items: center;
          padding-left: 10px;
        }

        div.split-line {
          display: flex;
          align-items: center;

          svg {
            margin-right: 4px;
            fill: white;
          }

          border-right: 2px solid rgba(255, 255, 255, 0.22);
          padding: 0 8px;
        }

        .icon-wrap {
          display: flex;
          align-items: center;

          svg {
            margin-right: 4px;
          }
        }
      }

      .navbar-space {
        flex-shrink: 1;
        flex-grow: 1;
      }

      .navbar-right {
        display: flex;
        align-items: center;
      }
    }

    .container-wrapper {
      display: flex;
      align-items: center;
      height: 85px;

      .search-wrap {
        flex-shrink: 1;
        flex-grow: 1;
        padding: 8px;

        &.driver-highlighted-element {
          background: #fb5533;
        }

        .search-box {
          .input-view {
            position: relative;

            div.icon {
              cursor: pointer;
              position: absolute;
              top: 0;
              bottom: 0;
              right: 10px;
              margin: auto;
              width: 60px;
              height: 34px;
              border-radius: 2px;
              background: #fb5533;
              display: flex;
              align-items: center;
              justify-content: center;

              &:hover {
                background: red;
              }

              svg {
                fill: white;
              }
            }

            input {
              width: 100%;
              height: 40px;
              font-size: 16px;
              padding: 0 10px;
              border-radius: 2px;
            }
          }

          .search-info {
            margin-top: 5px;
            color: white;
            padding: 4px;

            &.driver-highlighted-element {
              background: #fb5533;
            }

            span {
              cursor: pointer;
              margin-right: 12px;
              text-transform: capitalize;
              border: 1px solid transparent;

              &:hover {
                border: 1px solid #ffffff;
              }
            }
          }
        }
      }

      .logo {
        padding-left: 20px;
        padding-right: 40px;

        svg {
          width: 162px;
          height: 50px;
          fill: white;
        }
      }

      .shopcar {
        padding-left: 40px;
        padding-right: 20px;

        svg {
          width: 26px;
          height: 26px;
          fill: white;
        }
      }
    }
  }

  .el-scrollbar {
    height: 560px;
    width: 100%;
    display: block;

    &.hid {
      display: none;
    }
  }

  .main-container {
    background: #f5f5f5;

    .main-container-view {
      width: 990px;
      margin: auto;
    }

    .product-content,
    .seller-content {
      .section-title {
        display: flex;
        align-items: center;
        height: 25px;
        margin: 25px 6px;
        font-size: 14px;

        .section-title-txt {
          display: flex;
          align-items: center;
          flex: 1;

          .keyword {
            padding: 0 6px;
            font-size: 16px;

            > span {
              font-size: 16px;
              font-weight: 600;
              color: #ee4d2d;
            }
          }
        }

        .more-link {
          cursor: pointer;
          color: #ee4d2d;
          position: relative;

          .more-link-view {
            &.mark {
              transition: all 0.5s linear;
              border-color: #42b983;
              background: #42b983;
              position: relative;

              &:before {
                content: "";
                position: absolute;
                left: -4px;
                top: -4px;
                width: 100%;
                height: 100%;
                border: 2px solid #42b983;
                padding: 2px;
              }
            }
          }
        }
      }

      .seller-item {
        margin: 7px 6px;
        height: 120px;
        background: white;
        border-radius: 4px;
        transition: transform 0.1s cubic-bezier(0.4, 0, 0.6, 1),
          box-shadow 0.1s cubic-bezier(0.4, 0, 0.6, 1),
          -webkit-transform 0.1s cubic-bezier(0.4, 0, 0.6, 1);
        /*box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05);*/
        box-shadow: 0 0 2px #9e9e9e;
        padding: 0 20px;
        display: flex;
        align-items: center;

        &.mark {
          transition: all 0.5s linear;
          border-color: #42b983;
          background: #42b983;
          position: relative;

          &:before {
            content: "";
            position: absolute;
            left: -4px;
            top: -4px;
            width: 100%;
            height: 100%;
            border: 2px solid #42b983;
            padding: 2px;
          }
        }

        &.sellers {
          box-shadow: 0 0 10px #000000;
        }

        .shop-img {
          width: 70px;
          height: 70px;
          border: 1px solid #cacaca;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .shop-info {
          padding: 0 20px 0 10px;
          flex-basis: 300px;

          .info-item-nickname {
            font-size: 18px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 1.5;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .info-item-username {
            font-size: 14px;
            color: rgba(0, 0, 0, 0.8);
            line-height: 1.5;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }

          .info-item-follow {
            margin-top: 6px;
            color: #ee4d2d;
            font-size: 12px;
          }
        }

        .shop-statistics {
          display: flex;

          .shop-statistics-item {
            position: relative;

            &.mark {
              transition: all 0.5s linear;
              border-color: #42b983;
              background: #42b983;
              position: relative;

              &:before {
                content: "";
                position: absolute;
                left: -4px;
                top: -4px;
                width: 100%;
                height: 100%;
                border: 2px solid #42b983;
                padding: 2px;
              }
            }

            &.sales {
              box-shadow: 0 0 10px blue;
              border-radius: 10px;
              transition: all 0.5s linear;
            }

            &.sellers {
              box-shadow: 0 0 10px black;
              border-radius: 10px;
              transition: all 0.5s linear;
            }

            &.evaluate {
              box-shadow: 0 0 10px #00bcd4;
              border-radius: 10px;
              transition: all 0.5s linear;
            }

            .shop-statistics-item-wrapper.summary {
              box-shadow: 0 0 10px white;
              border-radius: 6px;
              padding: 10px;
              position: absolute;
              left: 0px;
              top: -10px;
              z-index: -10;
              color: white;
              opacity: 0;

              .item-header {
                svg {
                  fill: white;
                  color: white;
                }

                span {
                  color: white;
                }
              }

              &.active {
                transition: z-index 0s linear 0.6s, opacity 0.3s linear 0.6s;
                z-index: 10;
                opacity: 1;
              }
            }

            .shop-statistics-item-wrapper {
              border-left: 1px solid rgba(0, 0, 0, 0.09);
              padding: 0 10px;
              min-width: 90px;
              text-align: center;
              display: inline-block;

              .item-header {
                text-align: left;

                svg {
                  width: 14px;
                  height: 14px;
                  fill: currentColor;
                  color: #ee4d2d;
                  stroke: currentColor;
                  margin-right: 8px;
                }

                span {
                  font-size: 16px;
                  color: #ee4d2d;
                }
              }

              .item-text {
                text-align: left;
                margin-top: 8px;
              }
            }
          }
        }
      }
    }

    .product-content {
      &.hid {
        display: none;
      }

      div.product-wrapper {
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        margin-bottom: 20px;

        .product-item {
          display: block;
          color: rgba(0, 0, 0, 0.87);
          width: 184px;
          height: 321px;
          background: white;
          margin: 6px;
          border-radius: 4px;
          overflow: hidden;
          box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);

          .product-img {
            width: 186px;
            height: 186px;

            > img {
              height: 100%;
              object-fit: contain;
            }
          }

          div.product-details {
            margin: 7px;

            .product-title {
              font-size: 10px;
              height: 28px;
              word-wrap: break-word;
              line-height: 14px;
              overflow: hidden;
              display: -webkit-box;
              text-overflow: ellipsis;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              margin-bottom: 6px;
            }

            .product-seller {
              height: 16px;
              margin-top: 4px;

              span {
                color: white;
                border: 1px solid rgb(238, 77, 45);
                margin-right: 4px;
                padding: 0 2px;
                background: rgb(246, 145, 19);
              }
            }

            .product-price {
              color: #ee4d2d;
              margin-top: 5px;
              position: relative;
              font-size: 14px;

              span.sign {
                font-size: 10px;
              }

              span.price {
                font-size: 14px;
              }

              &.mark {
                transition: all 0.5s linear;
                border-color: #42b983;
                background: #42b983;
                position: relative;

                &:before {
                  content: "";
                  position: absolute;
                  left: -4px;
                  top: -4px;
                  width: 100%;
                  height: 100%;
                  border: 2px solid #42b983;
                  padding: 2px;
                }
              }
            }

            .product-other {
              height: 16px;
              margin-top: 6px;
            }

            .product-shop {
              margin-top: 6px;
              text-align: right;
              font-size: 10px;
              font-weight: 400;
              color: rgba(0, 0, 0, 0.65);
            }
          }
        }
      }

      div.filter-wrap {
        margin: 7px 6px;
        height: 60px;
        background: rgba(0, 0, 0, 0.03);
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        border-radius: 6px;

        .filter-condition {
          padding: 0 20px;
          display: flex;

          div.label {
            height: 34px;
            line-height: 34px;
            margin-right: 20px;
          }

          div.condition-items {
            display: flex;

            > div.item {
              cursor: pointer;
              margin-right: 10px;
              height: 34px;
              line-height: 34px;
              padding: 0 15px;
              background: white;
              color: #000000;

              &.active {
                color: white;
                background: #ee4d2d;
              }
            }
          }
        }

        .pagination-wrap {
          padding: 0 20px;
          display: flex;
          align-items: center;

          .num {
            margin-right: 20px;
          }

          .prev-next {
            display: flex;

            .btn {
              cursor: pointer;
              width: 34px;
              height: 34px;
              background: white;
              text-align: center;
              line-height: 34px;

              &:first-child {
                border-right: 1px solid rgba(0, 0, 0, 0.06);
              }

              &.disabled {
                cursor: inherit;
                background: #f9f9f9;
              }
            }
          }
        }
      }
    }

    .seller-content {
      min-width: 990px;

      &.hid {
        display: none;
      }

      &.active {
        position: absolute;
        z-index: 10;
      }
    }
  }
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
